import { Controller } from "@hotwired/stimulus"

// Toggles every `expandable` element inside the controller's element (e.g. the child rows of a
// <tbody> group) and rotates the `icon` chevron.
export default class extends Controller {
  static targets = ["expandable", "icon"]
  declare readonly expandableTargets: HTMLElement[]
  declare readonly iconTargets: HTMLElement[]

  toggle() {
    const isHidden = this.expandableTargets.some((el) =>
      el.classList.contains("hidden"),
    )
    this.expandableTargets.forEach((el) =>
      el.classList.toggle("hidden", !isHidden),
    )
    this.iconTargets.forEach((el) => {
      el.style.transform = isHidden ? "rotate(90deg)" : ""
    })
  }
}
